const AnalysisLevel =
{
    Account : "Account",
    Hierarchy : "Hierarchy",
    CustomGroup : "Custom Group"
}

export default AnalysisLevel;